<!-- @format -->

<agreement-modal>

  <style>
    .goto_notice_page_link {
      color: #00894B;
    }

    a.goto_notice_page_link:hover {
      text-decoration: underline;
    }

    .warning {
      color: #E02040;
      font-size: 1.4rem;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg"></div>
    <div class="modal__content">
      <h3 class="modal_heading margin-spacing-3_bottom">EDILENT利用規約(2022/04/01改定)</h3>

      <div style="margin-bottom: 1rem">
        <p class="warning">
          2022年4月1日に利用規約の改定を行いました。<br>
          詳細は<a class="goto_notice_page_link" href="/public/lp/release/20220318">こちら</a>からご確認ください。
        </p>
      </div>

      <div if={state.now_date <= 20220331} class="modal__content_inner">
        <rules-content-tag></rules-content-tag>
      </div>
      <div if={state.now_date >= 20220401} class="modal__content_inner">
        <rules-content-tag-20220401></rules-content-tag-20220401>
      </div>
      <!--/.modal__content_inner-->

      <div class="wrap_button margin-spacing-4_top">
        <input
          type="checkbox"
          name="rule"
          id="rule"
          class="checkbox-input"
          onclick="{ e=> onCheck(e) }"
        />
        <label for="rule" class="checkbox-parts">
          改定後の利用規約に同意する
        </label>
      </div><!--/.container_button-->	
      <div class="wrap_button margin-spacing-4_top">
        <button id="button" class="button button-primary button-primary-mini" type="button" value="登録する" onclick={props.onAgree} disabled>登録する</button>
      </div><!--/.container_button-->	

    </div>
    <!--modal__content-->
  </div>
  <!--modal-->






<script>
  import di from "dependency-injection";
  import rulesTag from '@tags/parts/edilent-worker-rules.riot';
  import rulesTag20220401 from '@tags/parts/edilent-worker-rules20220401after.riot';
  import base from "../modal-base.riot";
  export default {
    components: {
      "modal-base": base,
      "rules-content-tag": rulesTag,
      "rules-content-tag-20220401": rulesTag20220401,
    },
    state:{
      now_date : null,
    },
    onCheck(e){
      this.$('#button').disabled = !e.target.checked;
    },
    onBeforeMount(){
      let date = new Date();
      let month = (date.getMonth() + 1 <= 9) ? "0" + (date.getMonth() + 1).toString() : date.getMonth().toString();
      let day = (date.getDate()  <= 9) ? "0" + (date.getDate()).toString() : date.getDate().toString();
      this.state.now_date = parseInt( date.getFullYear() + month + day );
    }
  };
</script>
</agreement-modal>